function JoyTycoonIce(config) {
  myPixiElement.container.call(this);


  this.config = $.extend(true,{
        pos:[0,0],
        ice_id:0,
        factory_ids:[],
        add_ids:[],
        v:10,
        plate_index:0,
        scaleTo:[0,0],
        anchor:[0.5,0.5],
        need:{
            factory_ids: [],
        }
  },config);
  this.x=this.config.pos[0];
  this.y=this.config.pos[1];
  this.objectContainer=new myPixiElement.container({});
  this.objectArr=[];
  this.addChild(this.objectContainer);
  this.moveObj={dir:[0,0],step:0,step_max:0,pos_start:[0,0],scale_arr:[100,100]};
  this.storage={
      active:1,
      block_factory:0
  };
  this.init();
}
JoyTycoonIce.prototype = Object.create(myPixiElement.container.prototype);
JoyTycoonIce.prototype = $.extend(JoyTycoonIce.prototype, {
    takeState:function(){
        var type="ice";
        if(!arrayAreEqual(this.config.factory_ids,this.config.need.factory_ids)){
            type="";
        }
        return {type:type,id:this.config.ice_id,add_ids:this.config.add_ids};
    },
    isNeed:function(need){
        var state=this.takeState();
        if(need.type==state.type && need.id==state.id && arrayAreEqual(need.add_ids,state.add_ids)){
            return true;
        } 
        return false;
    },
    giveAddId:function(add_id){
        this.config.add_ids.push(add_id);
        this.updateView();
    },
    takePos:function(){
        return copyArray(this.config.pos);
    },
    takePlateIndex:function(){
        return this.config.plate_index;
    },
    blockFactory:function(factory_id){
        if(in_array(factory_id,this.config.need.factory_ids) && 
                !in_array(factory_id,this.config.factory_ids) && this.storage.block_factory==0){
            this.storage.block_factory=factory_id;
            return true;
        }
        return false;
    },
    releaseFactory:function(){
        this.config.factory_ids.push(this.storage.block_factory);
        this.updateView();
    },
    updateView:function(){
        this.objectContainer.removeChildren();
        
        var state=this.takeState();
        var pos=[0,-30];
        if(state.type==""){
            this.objectContainer.addChild(new myPixiElement.img({img:"ice"+state.id+"_part",pos:pos,anchor:this.config.anchor,scaleTo:this.config.scaleTo}));
        }
        else{
            this.objectContainer.addChild(new myPixiElement.img({img:"ice"+state.id,pos:pos,anchor:this.config.anchor,scaleTo:this.config.scaleTo}));
        }
        var i;
        var add_ids=copyArray(state.add_ids);
        add_ids.sort();
        for(i in add_ids){
            this.objectContainer.addChild(new myPixiElement.img({img:"add"+add_ids[i],pos:pos,anchor:this.config.anchor,scaleTo:this.config.scaleTo}));
        }
    },
    
    init:function(){
        this.updateView();
    },
    moveToPos:function(opt,onEnd){
        var conf=$.extend(true,{
            pos_end:[0,0],
            scale_arr:[100,100]
        },opt);
        var pos_start=[this.x,this.y];
        var dir=makeVector(pos_start,conf.pos_end);
        var step_max=lengthVector(dir)/this.config.v;
        this.moveObj=$.extend(true,this.moveObj,{
            dir:dir,
            step:0,
            scale_arr:conf.scale_arr,
            step_max:step_max,
            pos_start:pos_start,
            onEnd:onEnd
        });
    },
    isClick:function (pos) {
        var opos=[this.config.pos[0],this.config.pos[1]];
        var osize=[this.width,this.height];
        if(isInRegion(pos,opos,osize,this.config.anchor)){
            return 1;
        }
        return 0;


    },
    remove:function(){
        
    },
    myUpdate:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
        var thc=this;
        if(this.moveObj.step_max!=0){
            this.moveObj.step+=delta;
            var div=1;
            if(this.moveObj.step>=this.moveObj.step_max){
                this.moveObj.step=this.moveObj.step_max;
                this.moveObj.step_max=0;
            }
            else{
                div=this.moveObj.step/this.moveObj.step_max;
            }
            this.x=this.moveObj.dir[0]*div+this.moveObj.pos_start[0];
            this.y=this.moveObj.dir[1]*div+this.moveObj.pos_start[1];
            if(this.moveObj.scale_arr[0]!=this.moveObj.scale_arr[1]){
                var scale_int=this.scale_arr[0]+(this.scale_arr[1]-this.scale_arr[0])*div;
                this.scale.set(scale_int/100,scale_int/100);
            }
            
            
            if(this.moveObj.step_max==0){
                this.fadeOut(20,{onEnd:function(){
                    thc.storage.active=0;   
                }});
                if(typeof this.moveObj.onEnd!="undefined"){
                    this.moveObj.onEnd.call(this);
                }
            }
        }
        return this.storage.active;
    }
    
});

